export default "<p>\r\n  t-binary works!\r\n</p>\r\n"